import React from "react";
import styled from "styled-components";

const LoginButton = ({ title }) => {
  return <Button type="submit">{title}</Button>;
};

const Button = styled.button`
  width: 100%;
  color: white;
  background-color: #00db59;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  text-align: center;
  padding: 0.8rem;
  cursor: pointer;
  transition: background 0.3s ease;
  
  &:hover {
    background-color: #00c24e;
  }
`;
export default LoginButton;
